module.exports = __webpack_public_path__ + "img/logo_en_w.60386d62.svg";